//Third-party packages
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { startDeleteComisionista } from '../../redux/actions/comisionistas';

//Custom imports
import { uiManageModalNotification } from '../../redux/actions/ui';
import { Content } from './Content';

/**
 * 
    Author: QBK
    Date: 29-09-2021
 */
export const ConfirmDeleteComisionista = () => {
  const dispatch = useDispatch(); //react-redux hook to be able to dispatch the actions
  const { active } = useSelector(state => state.comisionistas); //we get the users from the state

  const handleSuccess = () => {
    dispatch(uiManageModalNotification()); //we close the confirmation modal
    dispatch(startDeleteComisionista(active.PkComisionistas)); //We dispatch the action passing as a parameter the user id
  };

  //The HTML is being rendered
  return (
    <Content
      title={'¿Quieres borrar el comisionista?'}
      text={'El comisionista quedará eliminado definitivamente del sistema'}
      action={handleSuccess}
    />
  );
};
